export interface EnvInterface {
  production: boolean;
  apiUrl: string;
  webAppUrl: string;
  whitelistedDomains: string[];
  mediaUrl: string;
}
